import { defineMessage } from 'services/localization';

export const messages = {
    popupTitle: defineMessage('twofactor_authentication_setup'),
    title: defineMessage('add_another_option_to_fall_back_on'),
    description: defineMessage('for_using_the_authentic_t_we_can_verify_its_you'),
    backupCodes: defineMessage('backup_codes'),
    backupEmail: defineMessage('backup_email'),
};
